<template>
  <v-list-tile
    :key="filter.index"
    @click="onViewFilter(filter)"
    ripple>

    <v-list-tile-content>
      <v-list-tile-title>{{ filter.title }}</v-list-tile-title>
      <v-list-tile-sub-title>{{ filter.description }}</v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action v-if="isAdmin">
      <v-btn @click.stop="editFilter(filter)" icon ripple>
        <v-icon color="grey lighten-1">edit</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-list-tile-action v-if="isAdmin">
      <v-btn @click.stop="removeFilter(filter)" icon ripple>
        <v-icon color="grey lighten-1">delete</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { db } from '@/db'

export default {
  name: 'FilterListItem',

  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters('auth', ['isAdmin'])
  },

  methods: {
    ...mapActions(['toggleModal', 'setSelectedItem']),

    onViewFilter (filter) {
      this.$router.push({
        name: 'ranges_path',
        params: {
          categoryId: filter.categoryId,
          subcategoryId: filter.subcategoryId,
          filterId: filter.id
        }
      })
    },

    editFilter (filter) {
      const filterObj = {
        id: filter.id,
        ...filter
      }

      this.setSelectedItem(filterObj)
      this.toggleModal()
    },

    removeFilter (filter) {
      this.$root.$confirm({
        title: 'Excluir Filtro'
      }).then((confirm) => {
        if (confirm) {
          let currentDocRef = db.collection('filters').doc(filter.id)

          currentDocRef.delete().then((success) => {
            console.log('Filter deleted!')
          }).catch((error) => {
            console.error('Error removing document: ', error)
          })
        }
      })
    }
  }
}
</script>
